import { Button, Tooltip } from 'antd'
import { PropsWithChildren } from 'react'
import { DisablableRowActionButtonProps } from './types'
import { useCIMSTableContext } from '../../../../../..'

function DisablableRowActionButton<T extends object>({
  record,
  callback,
  disabled,
  children,
}: PropsWithChildren<DisablableRowActionButtonProps<T>>) {
  const { setLoading } = useCIMSTableContext<T>()
  const resolved =
    typeof disabled === 'function' ? disabled(record) : disabled ?? false
  const button = (
    <Button
      type="link"
      disabled={resolved !== false}
      onClick={async () => {
        setLoading(true)
        await callback?.(record)
        setLoading(false)
      }}
      style={{ padding: 0, height: 'fit-content' }}
    >
      {children}
    </Button>
  )
  return resolved !== false ? (
    <Tooltip title={resolved.message}>{button}</Tooltip>
  ) : (
    button
  )
}

export default DisablableRowActionButton
